import { Col, List, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Empty } from 'src/components/Empty/Empty';
import { LoanApplicationStatusView } from 'src/components/LoanApplicationStatusView/LoanApplicationStatusView';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LoanApplicationDto, MerchantDto } from 'src/generated-api-client';
import styled from 'styled-components';

type MerchantApplicationsTabProps = {
    merchant?: MerchantDto;
};

export const MerchantApplicationsTab = observer(
    ({ merchant }: MerchantApplicationsTabProps) => {
        const applications = merchant?.loanApplications || ([] as any);

        return (
            <StyledList
                dataSource={applications}
                locale={{
                    emptyText: (
                        <Empty
                            description={t(
                                'Merchant.Applications.NoApplications',
                            )}
                        />
                    ),
                }}
                renderItem={(application) => {
                    const { id, number, status, createdAt, finalOffer } =
                        application as LoanApplicationDto;

                    const applicationDetailsId =
                        id && EntityLinks.loanApplications.itemDetails?.(id);

                    return (
                        <List.Item>
                            <StyledCard
                                onClick={() => {
                                    applicationDetailsId &&
                                        Router.navigate(applicationDetailsId);
                                }}
                            >
                                <Row gutter={[16, 16]}>
                                    <Col xs={12} sm={8} md={6}>
                                        <DataView
                                            label={t(
                                                'Merchant.Applications.ApplicationID',
                                            )}
                                            value={number}
                                        />
                                    </Col>
                                    <Col xs={12} sm={8} md={6}>
                                        <DataView
                                            label={t(
                                                'Merchant.Applications.Status',
                                            )}
                                            value={
                                                <LoanApplicationStatusView
                                                    status={status}
                                                />
                                            }
                                        />
                                    </Col>
                                    <Col xs={12} sm={8} md={6}>
                                        <DataView
                                            label={t(
                                                'Merchant.Applications.CreationDate',
                                            )}
                                            value={createdAt}
                                            formatValue="dateTime"
                                        />
                                    </Col>
                                    <Col xs={12} sm={8} md={6}>
                                        <DataView
                                            label={t(
                                                'Merchant.Applications.Amount',
                                            )}
                                            value={finalOffer?.financingAmount}
                                            formatValue="currency-sar"
                                        />
                                    </Col>
                                </Row>
                            </StyledCard>
                        </List.Item>
                    );
                }}
            />
        );
    },
);

const StyledList = styled(List)`
    margin-left: 0 !important;
`;

const StyledCard = styled(Card)`
    width: 100%;
`;
